/**
 * SGKC012A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SlideadjustmentunitpriceBasicInfo {

    /**
     * 会社名
     */
    companyname?: string;
    /**
     * エネルギー種別名称
     */
    energyClsname?: string;
    /**
     * ＬＰ販売形態名称
     */
    lpSalfrmAname?: string;
    /**
     * スライド調整単価コード
     */
    slideadjustmentunitpriceCode?: string;
    /**
     * スライド調整単価名称
     */
    slideadjustmentunitpriceAname?: string;
    /**
     * スライド調整単価登録権限コード
     */
    slideadjustmentunitpriceRegAuthoritycode?: string;
    /**
     * スライド調整単価承認権限コード
     */
    slideadjustmentunitpriceApprvAuthoritycode?: string;
    /**
     * 登録単位
     */
    registrationunit?: string;
    /**
     * スライド調整単価説明
     */
    slideadjustmentunitpriceExplanation?: string;
    /**
     * スライド調整単価メモ
     */
    slideadjustmentunitpriceMemo?: string;
    /**
     * スライド算定諸元登録フラグ
     */
    slidecalculationelementsRegFlg?: boolean;
}

